import React from "react"
import "./App.css"
import Game from "./components/Game"

function App() {
  return (
    <div className="App">
      <header className="Time Game"></header>
      <Game />
    </div>
  )
}

export default App
